import HttpRouter from '../services/HttpRouter'

module.exports = {

    methods: {
        get: function (url, options) {
            return HttpRouter.get(this, url, options);
        },
        delete: function (url, options) {
            return HttpRouter.delete(this, url, options);
        },
        post: function (url, data, options) {
            return HttpRouter.post(this, url, data, options);
        },
        put: function (url, data, options) {
            return HttpRouter.put(this, url, data, options);
        },
        patch: function (url, data, options) {
            return HttpRouter.patch(this, url, data, options);
        },
        batch: function () {
            return HttpRouter.batch(this);
        },
        loadToken: function(){
            return HttpRouter.loadToken();
        }
    }

};